import React, { useState } from "react";
import ApiService from "../services/ApiService";
import successImg from "../assets/img/success.gif";
import { toast } from "react-toastify";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useNavigate, Link } from "react-router-dom";

const PayPal = ({ interview_id, package_id, amount }) => {
  const [transactionId, setTransactionId] = useState(null);
  const clientId = process.env.REACT_APP_PYAPAL_CLIENT_ID;
  const navigate = useNavigate();

  const handleApprove = async (data, actions) => {
    const order = await actions.order.capture();
    const transactionId = order.id; // PayPal transaction ID
    const status = order.status; 
    setTransactionId(transactionId);

    if (interview_id > 0) {
      buyInterview(transactionId, status);
    } else if (package_id > 0) {
      buyPackage(transactionId, status);
    }
  };

  const buyInterview = async (transaction_id, status) => {
    try {
      const response = await ApiService.request({
        method: "POST",
        url: "/buyInterview",
        data: { interview_id, status, transaction_id },
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
      } else {
        toast.error(data.message || "Failed to process the purchase.");
      }
    } catch (error) {
      toast.error("An error occurred while processing your purchase.");
    }
  };

  const buyPackage = async (transaction_id, status) => {
    try {
      const response = await ApiService.request({
        method: "POST",
        url: "/purchasePackage",
        data: { package_id, status, transaction_id },
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
      } else {
        toast.error(data.message || "Failed to process the purchase.");
      }
    } catch (error) {
      toast.error("An error occurred while processing your purchase.");
    }
  };

  return (
    <PayPalScriptProvider options={{ "client-id": clientId, currency: "GBP", components: "buttons,applepay" }}>
      <div>
        {transactionId ? (
          <div className="text-center">
            <img src={successImg} alt="success" className="w-75" />
            <h3>Transaction ID: {transactionId}</h3>
            <Link className="btn btn-base" to="/dashboard"> Dashboard</Link>
          </div>
        ) : (
          <PayPalButtons
            createOrder={(data, actions) => {
              return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      value: amount, // Payment amount
                      currency_code: "GBP",
                    },
                  },
                ],
                application_context: {
                  shipping_preference: "NO_SHIPPING", 
                  locale: "en-GB", // Set locale to UK English
                },
                payer: {
                  address: {
                    country_code: "GB", // Set default billing country to UK
                  },
                },
              });
            }}
            onApprove={handleApprove}
            onError={(err) => console.error("PayPal Checkout Error:", err)}
          />
        )}
      </div>
    </PayPalScriptProvider>
  );
};

export default PayPal;
